import { FieldConfigReducerDispatch, FieldConfigReduxState, FieldConfigReduxType } from "./types";
const FIELD_CONFIG_INIT_STATE = {
    data: {},
    loading: false,
    error: null
}
const FieldConfigListReducer = (state: FieldConfigReduxState = FIELD_CONFIG_INIT_STATE, action: FieldConfigReducerDispatch) => {

    switch (action.type) {
        case FieldConfigReduxType.GET_FIELD_CONFIG: {
            return {
                ...state,
                loading: true
            }
        }
        case FieldConfigReduxType.GET_FIELD_CONFIG_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case FieldConfigReduxType.GET_FIELD_CONFIG_ERROR: {
            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        }
        default:
            return { ...state };
    }
}

export {
    FieldConfigListReducer
}